import GenerateAPI from '../generate.js'

let config = {
	ticketUpdate: {
		url: '/base/title/save'
	},
	ticketList: {
		url: '/base/title/list',
		apiType: 'check'
	}
}

const apiPayTicket = GenerateAPI.generate(config)

export default apiPayTicket
